exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var getUrl = require("../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL___0___ = getUrl(require("../images/accueil_background.jpg"));
// Module
exports.push([module.id, ".top-content{padding:210px 0;background-image:url(" + ___CSS_LOADER_URL___0___ + ")}.top-content .text{color:#fff}.top-content .text h1{margin-top:25px;color:#fff}.top-content .description{margin:30px 0 10px 0}.top-content .description p{opacity:0.8}.top-content .top-big-link{margin-top:45px}\n", ""]);
